import {
    MapOptions,
    BaseLayerType
} from "@esdm/map/dist";
import {SuffolkBaseLayerTypes } from "./SuffolkBaseMapping_3857"
import { LayerGroupCollection } from "@esdm/map/dist/layers/groups/LayerGroupCollection";


export class DefaultMapOptions {

    public static GetDefaultOptions(
        mapElementId: string,
        mapStoreKey: string
    ): MapOptions {       

        let opt = new MapOptions();       
        opt.bingApiKey = $(`#${mapElementId}`).data("bing-api-key");
        opt.esdmOsmApiKey = $(`#${mapElementId}`).data("esdm-osm-api-key");
        opt.baseMaps = [BaseLayerType.OSM, SuffolkBaseLayerTypes.SuffolkOS, SuffolkBaseLayerTypes.SuffolkAerial];
        opt.defaultBaseMap = BaseLayerType.OSM;
        opt.enableBoundsTracking = true;
        opt.mapElementId = mapElementId;
        opt.mapStoreKey = mapStoreKey;
        opt.mapZoom = 13;
        opt.minZoom = 9;
        opt.maxZoom = 19;
        opt.extent = [-611, 6760090, 206074, 6911130];
        opt.mapCentre = [128366, 6809507];
        opt.displayProjection = "EPSG:3857";
        opt.dataProjection = "EPSG:27700";
        opt.dragRotateAndZoom = false;       
        opt.zoomToNearestBounds = false;
        return opt;
    }

}